import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorShoppingCart() {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    blockSize: "330px",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.shoppingCart.errorTitle"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.shoppingCart.errorMessage"
        })]
      })
    })
  });
}
export default ErrorShoppingCart;